import { KeycloakConfig } from 'keycloak-js';

export interface CompanyConfig {
    name: string;
    label: string;
    id: string;
    fileMedia: any;
    default_currency: string;
}
export enum LOCALSTORAGE_KEYS {
    CURRENCY = "currencyId",
    COUNTRY = "countryId",
    TIMEZONE = "timezone",
    LOCALE = "locale"
}

export const kcConfig: KeycloakConfig = {
    url: 'https://auth.verygames.com/auth',
    //url: 'https://iam.verylys.net/auth',
    realm: 'verygames',
    clientId: 'verygames-client',// This is the client id which got generated by the 3scale in Keycloak . This client id referes to 3scale client id
}

export const CompanyConfig = {
    id: "6065b7eec47340ed44628cee"
}